import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import { token } from '@atlaskit/tokens';

export type CRFlag = {
	id: number;
	title: string;
	description: string;
};

type CodeReviewerFlagsProps = {
	flags: CRFlag[];
	setFlags: (newFlags: CRFlag[]) => void;
};

export const CodeReviewerFlags = ({ flags, setFlags }: CodeReviewerFlagsProps) => {
	const handleDismissFlag = () => {
		setFlags(flags.slice(1));
	};

	return (
		<FlagGroup onDismissed={handleDismissFlag}>
			{flags.map(({ id, title, description }) => (
				<AutoDismissFlag
					id={id}
					icon={<SuccessIcon primaryColor={token('color.icon.success')} label="Success" />}
					key={id}
					title={title}
					description={description}
				/>
			))}
		</FlagGroup>
	);
};
